import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'

import { parseLocation, makeLink, getQueryWithoutParam } from '../../../../common/utils/urlHelper'
import filterParamsConfig from '../../../../common/constants/filterParamsConfig'

const SearchNoResults = ({location}) => {
  const query = parseLocation(location)
  const filterParamsKeys = Object.keys(filterParamsConfig)
  const paramsList = Object.keys(query)
  const activeFiltersParams = filterParamsKeys.filter(param => paramsList.indexOf(param) > -1)

  const renderClearFiltersLink = () => {
    const queryWithoutFilters = getQueryWithoutParam(query, filterParamsKeys)
    return (
      <span>Try <Link to={makeLink(queryWithoutFilters)} className='fds-c-text-link -decoration-reversed'>
      clearing your filters</Link>.</span>
    )
  }

  return (
    <div className='fds-c-box -background-light fds-u-mb2 fds-u-p2'>
      <div className='search-no-results'>
        <div>
          <i className='e-icon -icon-cactus -size-enormous' />
        </div>
        <div>
          <h2 className='fds-c-text-heading -size-xs'>
            You've ventured too far out into the desert! {activeFiltersParams.length ? renderClearFiltersLink() : 'Time to head back'}
          </h2>
          <p className='fds-c-text-body'>{activeFiltersParams.length ? 'We couldn\'t find any results for your search within the filters you\'ve set.'
            : 'We couldn\'t find any results for your search. Use more generic words or double check your spelling.'}</p>
        </div>
      </div>
    </div>
  )
}

SearchNoResults.propTypes = {
  location: PropTypes.object
}

export default SearchNoResults



// WEBPACK FOOTER //
// ./client/pages/search/result/searchNoResults.js